import {
  ConnectionTypeEnum,
  PremiseDetails,
  ServiceTypeEnum,
  SortDirectionEnum,
  State,
} from "../Premises/types";

export enum TaskStatusEnum {
  ASSIGNED_TO_ME = "ASSIGNED_TO_ME",
  NEW_MESSAGE = "NEW_MESSAGE",
  COMPLETED = "COMPLETED",
}

export interface TaskOverview {
  premise: PremiseDetails;
  request_id: string;
  service_type: ServiceTypeEnum;
  task_added: string;
  task_status: TaskStatusEnum;
  connection_type: ConnectionTypeEnum;
  journey_id: string | null;
  distributor_application_id: string | null;
}

export type TasksTableRow = {
  serviceType: ServiceTypeEnum;
  connectionType: ConnectionTypeEnum;
  address: string;
  id: string;
  taskAdded: string;
  taskStatus: string;
  taskStatusText: string;
  journeyId: string | null;
  distributorApplicationId: string | null;
  requestStatus: TaskStatusEnum;
  state: State;
};

export enum SortByEnum {
  TASK_ADDED = "TASK_ADDED",
  TASK_STATUS = "TASK_STATUS",
  ADDRESS = "ADDRESS",
  CONNECTION_TYPE = "CONNECTION_TYPE",
  REQUEST_ID = "REQUEST_ID",
}

export interface FetchTasks {
  page?: number;
  limit?: number;
  sortDirection?: SortDirectionEnum;
  sortBy?: SortByEnum;
  incremental?: boolean;
}

export type TasksTableRows = TasksTableRow[];
